// enum matching type in the database
export var AppliedProductId;
(function (AppliedProductId) {
    AppliedProductId["AppliedPay"] = "appliedpay";
    AppliedProductId["Epic"] = "epic";
    AppliedProductId["EzLynx"] = "ezl";
    AppliedProductId["Csr24"] = "csr24";
    AppliedProductId["Mobile"] = "mob";
    AppliedProductId["Standalone"] = "standalone";
})(AppliedProductId || (AppliedProductId = {}));
//# sourceMappingURL=AppliedProductId.js.map